import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Exception } from '@/components/base/exception';

const PREFIX = 'State404';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    overflowY: 'auto',
  },
}));

export const State404: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Root className={classes.root}>
      <Exception subtitle="页面未找到">
        <Button onClick={() => navigate('/home')}>返回首页</Button>
      </Exception>
    </Root>
  );
};

export default State404;
